/** Minimum bbox confidence to accept for reconciliation (weak CV below this is dropped). */
export const MIN_CV_BOX_CONFIDENCE = 0.5;
